(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[™®©¹]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function parseJson(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.error('Royal Pop landing data could not be parsed.', error);
      return null;
    }
  }

  function parseJsonArray(node) {
    if (!node) return [];
    try {
      var value = JSON.parse(node.textContent || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_) {
      return [];
    }
  }

  function appendParams(rawHref, params) {
    if (!rawHref) return rawHref;
    var url;
    try {
      url = new URL(rawHref, window.location.origin);
    } catch (_) {
      return rawHref;
    }
    Object.keys(params || {}).forEach(function (key) {
      var value = params[key];
      if (value == null || value === '') url.searchParams.delete(key);
      else url.searchParams.set(key, String(value));
    });
    return url.origin === window.location.origin
      ? url.pathname + url.search + url.hash
      : url.toString();
  }

  function previewStackHtml() {
    return (
      '<div class="studio-preview__stack" data-studio-preview="active">' +
        '<div class="studio-preview__layer-wrap studio-preview__layer-wrap--b1-bottom">' +
          '<img class="studio-preview__layer studio-preview__layer--b1-bottom" data-layer="b1-bottom" alt="" loading="lazy" decoding="async">' +
        '</div>' +
        '<div class="studio-preview__layer-wrap studio-preview__layer-wrap--connector">' +
          '<img class="studio-preview__layer studio-preview__layer--connector" data-layer="connector" alt="" loading="lazy" decoding="async">' +
        '</div>' +
        '<div class="studio-preview__layer-wrap studio-preview__layer-wrap--b1-top">' +
          '<img class="studio-preview__layer studio-preview__layer--b1-top" data-layer="b1-top" alt="" loading="lazy" decoding="async">' +
        '</div>' +
        '<div class="studio-preview__layer-wrap studio-preview__layer-wrap--base">' +
          '<img class="studio-preview__layer studio-preview__layer--base" data-layer="base" alt="" loading="lazy" decoding="async">' +
        '</div>' +
        '<div class="studio-preview__layer-wrap studio-preview__layer-wrap--band">' +
          '<img class="studio-preview__layer studio-preview__layer--band" data-layer="band" alt="" loading="lazy" decoding="async">' +
        '</div>' +
      '</div>'
    );
  }

  function RoyalPopLanding(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id') || '';
    this.data = parseJson(document.getElementById('royal-pop-landing-data-' + this.sectionId));
    this.kit = window.B1PreviewKit || null;
    this.models = this.data && Array.isArray(this.data.models) ? this.data.models : [];
    this.bandEntries = this.data && Array.isArray(this.data.bandEntries) ? this.data.bandEntries : [];
    this.bandEntriesByProductId = Object.create(null);
    this.bandEntries.forEach(function (entry) {
      if (entry && entry.productId != null) this.bandEntriesByProductId[String(entry.productId)] = entry;
    }, this);
    this.cardEngines = [];
    this.imageSizeCache = Object.create(null);
    this.renderGeneration = 0;
    this.destroyed = false;

    if (!this.models.length) return;

    this.bindRails();
    this.bindModelCards();
    this.enhanceBandwareCards();
    this.selectedModel = this.resolveInitialModel();
    this.applyModel(this.selectedModel, { updateHistory: false, initial: true });

    this.onPopState = this.handlePopState.bind(this);
    window.addEventListener('popstate', this.onPopState);
  }

  RoyalPopLanding.prototype.destroy = function () {
    this.destroyed = true;
    if (this.onPopState) window.removeEventListener('popstate', this.onPopState);
    this.cardEngines.length = 0;
  };

  RoyalPopLanding.prototype.resolveModel = function (value) {
    if (value == null || value === '') return null;
    var raw = String(value);
    if (/^\d+$/.test(raw) && this.models[Number(raw)]) return this.models[Number(raw)];
    var target = normalize(raw);
    return this.models.find(function (model) {
      return normalize(model.slug) === target || normalize(model.name) === target;
    }) || null;
  };

  RoyalPopLanding.prototype.resolveInitialModel = function () {
    var params = new URLSearchParams(window.location.search || '');
    var fromUrl = this.resolveModel(params.get('model'));
    if (fromUrl) return fromUrl;
    var fromSetting = this.resolveModel(this.root.getAttribute('data-default-model'));
    return fromSetting || this.models[0];
  };

  RoyalPopLanding.prototype.bindModelCards = function () {
    var self = this;
    this.root.querySelectorAll('[data-royal-pop-model-choice]').forEach(function (button) {
      button.addEventListener('click', function () {
        var model = self.resolveModel(button.getAttribute('data-model-slug')) ||
          self.models[Number(button.getAttribute('data-model-index') || 0)];
        if (model) self.applyModel(model, { updateHistory: true });
      });
    });
  };

  RoyalPopLanding.prototype.bindRails = function () {
    this.root.querySelectorAll('.royal-pop-landing__model-shell, .royal-pop-landing__rail-shell').forEach(function (shell) {
      var track = shell.querySelector('[data-rail-track]');
      var previous = shell.querySelector('[data-rail-previous]');
      var next = shell.querySelector('[data-rail-next]');
      if (!track) return;

      function scroll(direction) {
        var amount = Math.max(220, track.clientWidth * 0.82);
        track.scrollBy({ left: direction * amount, behavior: 'smooth' });
      }

      if (previous) previous.addEventListener('click', function () { scroll(-1); });
      if (next) next.addEventListener('click', function () { scroll(1); });
    });
  };

  RoyalPopLanding.prototype.handlePopState = function () {
    var model = this.resolveModel(new URLSearchParams(window.location.search || '').get('model'));
    if (model) this.applyModel(model, { updateHistory: false });
  };

  RoyalPopLanding.prototype.applyModel = function (model, options) {
    if (!model || this.destroyed) return;
    options = options || {};
    this.selectedModel = model;
    this.renderGeneration += 1;

    this.syncModelCards(model);
    this.syncLinks(model);
    this.syncWatchwareCards(model);
    this.renderFeaturePreviews(model, this.renderGeneration);
    this.renderBandwareCards(model, this.renderGeneration);

    if (options.updateHistory) {
      var url = new URL(window.location.href);
      url.searchParams.set('model', model.slug);
      history.replaceState({ royalPopModel: model.slug }, '', url.pathname + url.search + url.hash);
    }

    document.dispatchEvent(new CustomEvent('royal-pop:model-change', {
      detail: { modelSlug: model.slug, source: 'royal-pop-landing' }
    }));
  };

  RoyalPopLanding.prototype.syncModelCards = function (model) {
    this.root.querySelectorAll('[data-royal-pop-model-choice]').forEach(function (button) {
      var selected = normalize(button.getAttribute('data-model-slug')) === normalize(model.slug);
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
  };

  RoyalPopLanding.prototype.syncLinks = function (model) {
    var frameFinish = this.data && this.data.frame ? this.data.frame.finish : '';

    this.root.querySelectorAll('[data-model-link]').forEach(function (anchor) {
      var base = anchor.getAttribute('data-base-href') || anchor.getAttribute('href');
      anchor.setAttribute('href', appendParams(base, { model: model.slug }));
    });

    this.root.querySelectorAll('[data-bandware-model-link]').forEach(function (anchor) {
      var base = anchor.getAttribute('data-base-href') || anchor.getAttribute('href');
      var finish = anchor.getAttribute('data-frame-finish') || frameFinish;
      anchor.setAttribute('href', appendParams(base, {
        device: 'royal-pop',
        mode: 'direct',
        model: model.slug,
        frame_type: 'steel',
        frame_finish: finish,
        frame: finish
      }));
    });

    this.root.querySelectorAll('[data-studio-model-link]').forEach(function (anchor) {
      var base = anchor.getAttribute('data-base-href') || anchor.getAttribute('href');
      var finish = anchor.getAttribute('data-frame-finish') || frameFinish;
      anchor.setAttribute('href', appendParams(base, {
        device: 'royal-pop',
        mode: 'direct',
        model: model.slug,
        frame_type: 'steel',
        frame_finish: finish,
        frame: finish
      }));
    });

    this.root.querySelectorAll('[data-royal-pop-product-rail]').forEach(function (rail) {
      var kind = rail.getAttribute('data-rail-kind');
      rail.querySelectorAll('a[href]').forEach(function (anchor) {
        if (!anchor.dataset.royalPopBaseHref) anchor.dataset.royalPopBaseHref = anchor.getAttribute('href') || '';
        if (kind === 'bandware') {
          anchor.setAttribute('href', appendParams(anchor.dataset.royalPopBaseHref, {
            device: 'royal-pop',
            mode: 'direct',
            model: model.slug,
            frame_type: 'steel',
            frame_finish: frameFinish,
            frame: frameFinish
          }));
        } else {
          anchor.setAttribute('href', appendParams(anchor.dataset.royalPopBaseHref, { model: model.slug }));
        }
      });
    });
  };

  RoyalPopLanding.prototype.rememberImageSource = function (image) {
    if (!image || image.dataset.royalPopLandingOriginalRemembered === 'true') return;
    image.dataset.royalPopLandingOriginalRemembered = 'true';
    image.dataset.royalPopLandingOriginalSrc = image.getAttribute('src') || '';
    image.dataset.royalPopLandingOriginalSrcset = image.getAttribute('srcset') || '';
    image.dataset.royalPopLandingOriginalSizes = image.getAttribute('sizes') || '';
  };

  RoyalPopLanding.prototype.setImageBase = function (image, alternateUrl) {
    if (!image) return;
    this.rememberImageSource(image);
    if (alternateUrl) {
      image.setAttribute('src', alternateUrl);
      image.setAttribute('srcset', alternateUrl);
      image.removeAttribute('sizes');
      image.dataset.royalPopLandingUsingAlternate = 'true';
    } else if (image.dataset.royalPopLandingUsingAlternate === 'true') {
      image.setAttribute('src', image.dataset.royalPopLandingOriginalSrc || '');
      if (image.dataset.royalPopLandingOriginalSrcset) image.setAttribute('srcset', image.dataset.royalPopLandingOriginalSrcset);
      else image.removeAttribute('srcset');
      if (image.dataset.royalPopLandingOriginalSizes) image.setAttribute('sizes', image.dataset.royalPopLandingOriginalSizes);
      else image.removeAttribute('sizes');
      delete image.dataset.royalPopLandingUsingAlternate;
    }
  };

  RoyalPopLanding.prototype.isThreeClock = function (model) {
    return normalize(model && model.crownPosition).indexOf('3-o-clock') === 0 ||
      String(model && model.crownPosition || '').trim().indexOf('3') === 0;
  };

  RoyalPopLanding.prototype.bindWatchwareSlider = function (slider) {
    if (!slider || slider.dataset.royalPopLandingBound === 'true') return;
    slider.dataset.royalPopLandingBound = 'true';
    var self = this;

    function sync() { self.syncWatchwareOverlayState(slider); }
    slider.addEventListener('pointerenter', sync);
    slider.addEventListener('pointerleave', sync);
    slider.addEventListener('click', function () { requestAnimationFrame(sync); });
    slider.addEventListener('scroll', sync, { passive: true });

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function (mutations) {
        if (mutations.some(function (mutation) { return mutation.attributeName === 'data-current-slide'; })) sync();
      });
      observer.observe(slider, { attributes: true, attributeFilter: ['data-current-slide'] });
    }
  };

  RoyalPopLanding.prototype.syncWatchwareOverlayState = function (slider) {
    if (!slider) return;
    var mobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var currentIndex = Math.max(0, Number.parseInt(slider.dataset.currentSlide || '1', 10) - 1);
    slider.querySelectorAll(':scope > .royal-pop-landing__watchware-overlay').forEach(function (overlay) {
      var index = Number.parseInt(overlay.dataset.slideIndex || '0', 10);
      overlay.classList.toggle('is-active', mobile || index === currentIndex);
    });
  };

  RoyalPopLanding.prototype.syncWatchwareCards = function (model) {
    var self = this;
    var gallery = Array.isArray(model.gallery) ? model.gallery.filter(Boolean) : [];
    var useThreeClock = this.isThreeClock(model);

    this.root.querySelectorAll('[data-royal-pop-product-rail][data-rail-kind="watchware"] .card-product__slider').forEach(function (slider) {
      var originalImages = Array.from(slider.querySelectorAll(':scope > img'));
      var alternateGallery = parseJsonArray(slider.parentElement && slider.parentElement.querySelector('[data-royal-pop-card-3-gallery]'));
      originalImages.forEach(function (image, index) {
        self.setImageBase(image, useThreeClock ? (alternateGallery[index] || '') : '');
      });

      var existing = new Map();
      slider.querySelectorAll(':scope > .royal-pop-landing__watchware-overlay').forEach(function (node) {
        existing.set(Number(node.dataset.slideIndex), node);
      });

      self.bindWatchwareSlider(slider);
      slider.classList.toggle('royal-pop-landing__watchware-slider', gallery.length > 0);

      originalImages.forEach(function (_, index) {
        var url = gallery[index] || '';
        var overlay = existing.get(index);
        if (!url) {
          if (overlay) overlay.remove();
          existing.delete(index);
          return;
        }
        if (!overlay) {
          overlay = document.createElement('span');
          overlay.className = 'royal-pop-landing__watchware-overlay';
          overlay.dataset.slideIndex = String(index);
          overlay.setAttribute('aria-hidden', 'true');
          slider.appendChild(overlay);
        }
        overlay.style.setProperty('--royal-pop-slide-index', String(index));
        overlay.style.backgroundImage = 'url("' + String(url).replace(/"/g, '\\"') + '")';
        existing.delete(index);
      });

      existing.forEach(function (node) { node.remove(); });
      self.syncWatchwareOverlayState(slider);
    });
  };

  RoyalPopLanding.prototype.getGeometry = function (model) {
    if (!this.kit || !this.kit.parseStudioGeometry) return null;
    var geometry = this.kit.parseStudioGeometry(model && model.scaleData);
    if (this.kit.applyRoyalCrownPositionGeometry) {
      geometry = this.kit.applyRoyalCrownPositionGeometry(geometry, model && model.crownPosition);
    }
    return geometry || null;
  };

  RoyalPopLanding.prototype.buildRoyalBandLayers = function (model, bandEntry) {
    if (!model || !bandEntry) return null;
    var geometry = this.getGeometry(model);
    var frame = this.data && this.data.frame ? this.data.frame : {};
    return {
      base: model.deviceImage || null,
      band: bandEntry.topBand || null,
      connector: bandEntry.bottomBand || null,
      showConnector: !!bandEntry.bottomBand,
      b1FrameBack: frame.image || null,
      showB1FrameBack: !!frame.image,
      showB1Connectors: false,
      b1Connector: null,
      normalizeBase: true,
      royalDirectComposition: true,
      crownPosition: model.crownPosition || null,
      royalOffsetX: geometry && geometry.offsetX != null ? geometry.offsetX : 0,
      royalOffsetY: geometry && geometry.offsetY != null ? geometry.offsetY : 0,
      royalOffsetXRatio: geometry && geometry.offsetXRatio != null ? geometry.offsetXRatio : null,
      royalOffsetYRatio: geometry && geometry.offsetYRatio != null ? geometry.offsetYRatio : null,
      royalCrownOffsetXRatio: geometry && geometry.crownOffsetXRatio != null ? geometry.crownOffsetXRatio : null,
      royalCrownOffsetYRatio: geometry && geometry.crownOffsetYRatio != null ? geometry.crownOffsetYRatio : null
    };
  };

  RoyalPopLanding.prototype.getImageSize = function (url) {
    var self = this;
    if (!url) return Promise.resolve(null);
    if (this.imageSizeCache[url]) return this.imageSizeCache[url];
    if (this.kit && this.kit.loadImageNaturalSize) {
      this.imageSizeCache[url] = this.kit.loadImageNaturalSize(url);
      return this.imageSizeCache[url];
    }
    this.imageSizeCache[url] = new Promise(function (resolve) {
      var image = new Image();
      image.onload = function () { resolve({ w: image.naturalWidth, h: image.naturalHeight }); };
      image.onerror = function () { resolve(null); };
      image.src = url;
    });
    return self.imageSizeCache[url];
  };

  RoyalPopLanding.prototype.withStrapRatio = function (layers) {
    var self = this;
    if (!layers || !layers.base || !layers.band) return Promise.resolve(layers);
    return Promise.all([this.getImageSize(layers.base), this.getImageSize(layers.band)]).then(function (sizes) {
      var baseSize = sizes[0];
      var bandSize = sizes[1];
      if (baseSize && bandSize && baseSize.h > 1 && bandSize.h > 1) {
        layers.strapHeightRatio = bandSize.h / baseSize.h;
      }
      return layers;
    }).catch(function () { return layers; });
  };

  RoyalPopLanding.prototype.renderFeaturePreviews = function (model, generation) {
    if (!this.kit || !this.kit.PreviewEngine) return;
    this.renderWatchwareFeature(model, generation);
    this.renderBandwareFeature(model, generation);
  };

  RoyalPopLanding.prototype.getFeatureEngine = function (selector, key) {
    var host = this.root.querySelector(selector);
    if (!host) return null;
    var previewRoot = host.querySelector('[data-preview-root]');
    if (!previewRoot) return null;
    if (!this[key]) this[key] = new this.kit.PreviewEngine(previewRoot);
    return { host: host, root: previewRoot, engine: this[key] };
  };

  RoyalPopLanding.prototype.renderWatchwareFeature = function (model, generation) {
    var feature = this.getFeatureEngine('[data-royal-pop-watchware-preview]', 'watchwareFeatureEngine');
    var data = this.data && this.data.featuredWatchware;
    if (!feature || !data || !data.base || !data.topBand) return;

    feature.host.hidden = false;
    var media = feature.host.closest('[data-feature-media]');
    var layers = {
      base: data.base,
      band: data.topBand,
      connector: data.bottomBand || null,
      showConnector: !!data.bottomBand,
      watchwareComposition: true,
      royalWatchwareModelBase: model.watchwareImage || null,
      royalWatchwareModelName: model.name || ''
    };
    var view = { active: layers, single: true };
    if (!feature.engine.isValidView(view)) return;

    var self = this;
    this.kit.renderCollectionCardPreview(feature.engine, view, true).then(function () {
      if (self.destroyed || generation !== self.renderGeneration) return;
      if (media) media.classList.add('is-preview-ready');
    });
  };

  RoyalPopLanding.prototype.renderBandwareFeature = function (model, generation) {
    var feature = this.getFeatureEngine('[data-royal-pop-bandware-preview]', 'bandwareFeatureEngine');
    var band = this.data && this.data.featuredBandware;
    if (!feature || !band || !band.topBand || !model.deviceImage) return;

    feature.host.hidden = false;
    var media = feature.host.closest('[data-feature-media]');
    var layers = this.buildRoyalBandLayers(model, band);
    var self = this;
    this.withStrapRatio(layers).then(function (readyLayers) {
      if (self.destroyed || generation !== self.renderGeneration) return;
      var view = { active: readyLayers, single: true };
      if (!feature.engine.isValidView(view)) return;
      return self.kit.renderCollectionCardPreview(feature.engine, view, true, true).then(function () {
        if (self.destroyed || generation !== self.renderGeneration) return;
        if (media) media.classList.add('is-preview-ready');
      });
    });
  };

  RoyalPopLanding.prototype.enhanceBandwareCards = function () {
    var self = this;
    this.root.querySelectorAll('[data-royal-pop-product-rail][data-rail-kind="bandware"] [data-royal-pop-product-id]').forEach(function (slide) {
      var productId = slide.getAttribute('data-royal-pop-product-id');
      var entry = self.bandEntriesByProductId[String(productId)];
      if (!entry) return;
      var media = slide.querySelector('.card__media');
      if (!media) return;

      var host = slide.querySelector('[data-royal-pop-band-card-preview]');
      if (!host) {
        host = document.createElement('div');
        host.className = 'royal-pop-landing__card-preview-host';
        host.setAttribute('data-royal-pop-band-card-preview', '');
        host.setAttribute('aria-hidden', 'true');
        host.innerHTML =
          '<div class="studio-collection-card-preview studio is-ww-js-layout is-royal-device is-rp-bandware-tab is-bandware-tab" data-preview-root>' +
            previewStackHtml() +
          '</div>';
        media.appendChild(host);
      }

      var previewRoot = host.querySelector('[data-preview-root]');
      if (!previewRoot || !self.kit || !self.kit.PreviewEngine) return;
      var engine = new self.kit.PreviewEngine(previewRoot);
      self.cardEngines.push({ slide: slide, host: host, engine: engine, entry: entry });
    });
  };

  RoyalPopLanding.prototype.renderBandwareCards = function (model, generation) {
    if (!this.kit || !this.cardEngines.length) return;
    var self = this;
    this.cardEngines.forEach(function (item) {
      item.host.classList.remove('is-ready');
      item.slide.classList.remove('is-composed');
      var layers = self.buildRoyalBandLayers(model, item.entry);
      self.withStrapRatio(layers).then(function (readyLayers) {
        if (self.destroyed || generation !== self.renderGeneration) return;
        var view = { active: readyLayers, single: true };
        if (!item.engine.isValidView(view)) return;
        return self.kit.renderCollectionCardPreview(item.engine, view, true, true).then(function () {
          if (self.destroyed || generation !== self.renderGeneration) return;
          var stack = item.engine.stacks && item.engine.stacks.active;
          var base = stack && stack.querySelector('[data-layer="base"]');
          var band = stack && stack.querySelector('[data-layer="band"]');
          if (!base || !band || !base.getAttribute('src') || !band.getAttribute('src')) return;
          item.host.classList.add('is-ready');
          item.slide.classList.add('is-composed');
        });
      });
    });
  };

  function boot(root) {
    if (!root) return;
    if (root.__royalPopLandingInstance) root.__royalPopLandingInstance.destroy();
    root.__royalPopLandingInstance = new RoyalPopLanding(root);
  }

  function bootAll(scope) {
    (scope || document).querySelectorAll('[data-royal-pop-landing]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(document); });
  } else {
    bootAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootAll(event.target || document);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector && event.target.querySelector('[data-royal-pop-landing]');
    if (root && root.__royalPopLandingInstance) {
      root.__royalPopLandingInstance.destroy();
      root.__royalPopLandingInstance = null;
    }
  });
})();
